/**
 * Status → chart fill. These are *status* colors, not a categorical series
 * palette: each one names a state, so it is never reassigned to "the next
 * series". Every chart that uses them must also carry a visible label, because
 * status may never be communicated by color alone.
 */
export type StatusTone = 'success' | 'info' | 'warn' | 'danger' | 'idle';

export const STATUS_FILL: Readonly<Record<StatusTone, string>> = {
  success: 'var(--chart-success)',
  info: 'var(--chart-info)',
  warn: 'var(--chart-warn)',
  danger: 'var(--chart-danger)',
  idle: 'var(--chart-idle)',
};

export interface ChartDatum {
  readonly label: string;
  readonly value: number;
  readonly tone: StatusTone;
}
